'use strict';
Object.defineProperty(exports, '__esModule', { value: true });
var prefix = 'fal';
var iconName = 'school';
var width = 576;
var height = 512;
var aliases = [127979];
var unicode = 'f549';
var svgPathData = 'M268.2 19.3c11.6-9.2 28-9.2 39.7 0L445.6 128 512 128c35.3 0 64 28.7 64 64l0 256c0 35.3-28.7 64-64 64L64 512c-35.3 0-64-28.7-64-64L0 192c0-35.3 28.7-64 64-64l66.4 0 137.7-108.7zM256 480l64 0 0-96c0-8.8-7.2-16-16-16l-32 0c-8.8 0-16 7.2-16 16l0 96zm96 0l160 0c17.7 0 32-14.3 32-32l0-256c0-17.7-14.3-32-32-32l-72 0c-3.6 0-7.1-1.2-9.9-3.4L288 44.4 145.9 156.6c-2.8 2.2-6.3 3.4-9.9 3.4l-72 0c-17.7 0-32 14.3-32 32l0 256c0 17.7 14.3 32 32 32l160 0 0-96c0-26.5 21.5-48 48-48l32 0c26.5 0 48 21.5 48 48l0 96zM144 384c0 8.8-7.2 16-16 16l-16 0c-8.8 0-16-7.2-16-16l0-16c0-8.8 7.2-16 16-16l16 0c8.8 0 16 7.2 16 16l0 16zm-16-96l-16 0c-8.8 0-16-7.2-16-16l0-16c0-8.8 7.2-16 16-16l16 0c8.8 0 16 7.2 16 16l0 16c0 8.8-7.2 16-16 16zm352 96c0 8.8-7.2 16-16 16l-16 0c-8.8 0-16-7.2-16-16l0-16c0-8.8 7.2-16 16-16l16 0c8.8 0 16 7.2 16 16l0 16zm-16-96l-16 0c-8.8 0-16-7.2-16-16l0-16c0-8.8 7.2-16 16-16l16 0c8.8 0 16 7.2 16 16l0 16c0 8.8-7.2 16-16 16zM288 224a32 32 0 1 0 0-64 32 32 0 1 0 0 64zm0-96a64 64 0 1 1 0 128 64 64 0 1 1 0-128z';

exports.definition = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    aliases,
    unicode,
    svgPathData
  ]};

exports.faSchool = exports.definition;
exports.prefix = prefix;
exports.iconName = iconName;
exports.width = width;
exports.height = height;
exports.ligatures = aliases;
exports.unicode = unicode;
exports.svgPathData = svgPathData;
exports.aliases = aliases;